import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const Home = lazy(() => import("../../Pages/Home/Home"));
const LoginPage = lazy(() => import("../../auth/LoginPage/LoginPage"));
const VerifyPage = lazy(() => import("../../auth/VerifyPage/VerifyPage"));
const RegisterPage = lazy(() => import("../../auth/RegisterPage/RegisterPage"));
const CheckEmailPage = lazy(() =>
  import("../../auth/CheckEmailPage/CheckEmailPage"),
);
const SuccessPage = lazy(() => import("../../auth/SuccessPage/SuccessPage"));
const ResetPasswordPage = lazy(() =>
  import("../../auth/ResetPasswordPage/ResetPasswordPage"),
);
const ProductsPage = lazy(() => import("../../Pages/ProductsPage/ProductsPage"));
const ProductDetailsPage = lazy(() =>
  import("../../Pages/ProductDetailsPage/ProductDetailsPage"),
);
const CategoriesPage = lazy(() =>
  import("../../Pages/CategoriesPage/CategoriesPage"),
);
const ShoppingCartPage = lazy(() =>
  import("../../Pages/ShoppingCartPage/ShoppingCartPage"),
);
const CheckoutPage = lazy(() => import("../../Pages/CheckoutPage/CheckoutPage"));
const SubCategoriesPage = lazy(() =>
  import("../../Pages/CategoriesPage/SubCategoriesPage"),
);
const AboutUs = lazy(() => import("../../Pages/AboutUs/AboutUs"));
const Privacy = lazy(() => import("../../Pages/Privacy/Privacy"));
const Portal = lazy(() => import("../../Pages/Portal/Portal"));
const Profile = lazy(() => import("../../Pages/Profile/Profile"));

function PortalRoutes() {
  return (
    <Routes>
      <Route path="/portal" element={<Portal />} />
    </Routes>
  );
}

function AppRoutes({
  data,
  products,
  contentData,
  innerPageData,
  itemData,
  categoryData,
  url,
  apiMethod,
  translations,
  language,
  limit,
  serviceId,
}) {
  const homeProps = {
    data,
    products,
    contentData,
    innerPageData,
    itemsList: itemData,
    categoryList: categoryData,
    url,
    apiMethod,
    translations,
    language,
  };

  return (
    <Routes>
      <Route index element={<Home {...homeProps} />} />
      <Route path="/home" element={<Home {...homeProps} />} />
      <Route
        path="/login"
        element={
          <LoginPage
            url={url}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/register"
        element={
          <RegisterPage
            url={url}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/checkEmail"
        element={<CheckEmailPage url={url} translations={translations} />}
      />
      <Route
        path="/verify"
        element={<VerifyPage translations={translations} />}
      />
      <Route
        path="/success"
        element={<SuccessPage translations={translations} />}
      />
      <Route
        path="/resetPassword"
        element={<ResetPasswordPage url={url} translations={translations} />}
      />
      <Route
        path="/products"
        element={
          <ProductsPage
            data={data}
            url={url}
            limit={limit}
            apiMethod={apiMethod}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/product/:id"
        element={
          <ProductDetailsPage
            url={url}
            apiMethod={apiMethod}
            serviceId={serviceId}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/categories"
        element={
          <CategoriesPage
            data={data}
            url={url}
            limit={limit}
            apiMethod={apiMethod}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/categories/:id"
        element={
          <SubCategoriesPage
            data={data}
            url={url}
            apiMethod={apiMethod}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/shoppingCart"
        element={
          <ShoppingCartPage
            url={url}
            apiMethod={apiMethod}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/shoppingCart/checkout"
        element={
          <CheckoutPage
            url={url}
            apiMethod={apiMethod}
            translations={translations}
            language={language}
          />
        }
      />
      <Route
        path="/about"
        element={<AboutUs url={url} data={data} translations={translations} />}
      />
      <Route path="/privacy" element={<Privacy data={data} />} />
      <Route
        path="/profile"
        element={
          <Profile
            url={url}
            translations={translations}
            language={language}
          />
        }
      />
    </Routes>
  );
}

export { AppRoutes, PortalRoutes };
